import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "onChange", "locale", "value", "className"];
import React, { forwardRef, useEffect, useRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { useManyRefs, useScrollToItem } from '@carnica/utils/hooks';
import { format, isSameMonth } from 'date-fns-new';
import { Text } from "../../Text";
import { useHorizontalWheelScroll } from "../../../hooks/useHorizontalWheelScroll";
import styles from "./styles.pcss";
var cnMonthSelector = cnBem('month-selector', styles);
export var MonthSelector = /*#__PURE__*/forwardRef(function (props, ref) {
  var items = props.items,
    onChange = props.onChange,
    locale = props.locale,
    value = props.value,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var listRef = useRef(null);
  useHorizontalWheelScroll(listRef);
  var activeIndex = items.findIndex(function (el) {
    return isSameMonth(value, el);
  });
  var refs = useManyRefs(items.length);
  var scrollToItem = useScrollToItem({
    containeRef: listRef,
    itemRefs: refs
  });
  useEffect(function () {
    scrollToItem(activeIndex);
  }, [activeIndex]);
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cnMonthSelector(null, [className]),
    ref: combineRefs([ref, listRef])
  }, otherProps, {
    "data-t-id": "DatePicker-MonthSelector"
  }), items.map(function (date, i) {
    var stringMonth = format(date, 'LLLL', {
      locale: locale
    });
    return /*#__PURE__*/React.createElement(Text, {
      "aria-label": stringMonth,
      className: cnMonthSelector('item', {
        active: activeIndex === i
      }),
      key: cnMonthSelector('item', {
        i: i
      }),
      onClick: function onClick(e) {
        return onChange === null || onChange === void 0 ? void 0 : onChange(date, e);
      },
      ref: refs[i],
      role: "button",
      tabIndex: 0,
      tagName: "li",
      variant: "body-medium"
    }, stringMonth);
  }));
});